import { useEffect, useState } from 'react';
import Reporting from './pages/home/Reporting';
import NeuAnmelden from './pages/home/NeuAnmelden';
//import Logout from './pages/home/Logout';
import './App.css';
import { AppState, DefaultProps } from './types/types';
import { CssBaseline, ThemeProvider, StyledEngineProvider, Box } from '@mui/material';
import { BASIC_THEME, selectTheme } from './themes/BasicTheme';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import Trustelement from './components/trustelement/Trustelement';
import { getCustomizingID, initLogger } from './util/util';


import './assets/css/google.fonts.css';
import './assets/css/frutiger.fonts.css';
import './assets/css/klavica.font.css';

import "@mui/system";
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import GreetingElement from './components/greetingElement/GreetingElement';
import { loadStorageData, KEY_AUTH_CONTEXT, saveSessionData } from './util/store';
import { AuthKey, AuthKeyValue, ArrayOfAuthKeyValue, AuthContext } from "./types/apimodel";
import Error404 from './pages/error404/Error404';
import LinkedappBackend from "./services/LinkedappBackend";
import { FilterProvider } from './components/reporting/filterpanel/useFilterCtx';
import CustomerDataProvider from './components/context/CustomerDataProvider';
import Account from "./pages/account/Account";
import ContactChange from './pages/account/ContactChange';
import Landing from './pages/landing/Landing';
import { LandingSubmitType } from './types/landingTypes';
import LandingEmailAuswahl from './pages/landing/LandingEmailAuswahl';
import LandingProvider from './pages/landing/LandingProvider';
import SignupDanke from './pages/landing/SignupDanke';
import Impressum from './components/cms/impressum';



//@mui/styles was deprecated with the release of MUI Core v5 in late 2021. It depended on JSS as a styling solution, which is no longer used in @mui/material . @mui/styles is not compatible with React. StrictMode or React 18, and it will not be updated.
/*
declare module '@mui/system/defaultTheme' {
  interface DefaultTheme extends Theme { }
}
*/

interface ApplicationProps extends DefaultProps {

}



function getParameter(name: string) {
  let params = new URLSearchParams(window.location.href);
  return params.get(name) || '';
}


function sindLinkParameterVorhanden(){
    let result =  getParameter('linkid') !== "";
    return result;
}

function getLandingPageMandantForLandingPage(){
  //default
  let result = "rl";
  if (window.location.href.includes("rhl.ag")) {
    result = "rl"
  } if (window.location.href.includes("rhion.ag")) {
    result = "rd"
  } 
  return "/landing/registrieren?cid="+result;
}

getLandingPageMandantForLandingPage();


function initTokenAuth() {
  console.log("initTokenAuth");

  const authTokenParam = getParameter('authtoken');
  if (authTokenParam) {
    const authKeyValue: AuthKeyValue = { key: AuthKey.TAN_TOKEN, value: getParameter('authtoken') };
    let authKeyValueArrayInner: AuthKeyValue[] = [authKeyValue];
    let arrayOfAuthKeyValue: ArrayOfAuthKeyValue = { value: authKeyValueArrayInner };
    let authContext: AuthContext = { value: arrayOfAuthKeyValue };
    saveSessionData(KEY_AUTH_CONTEXT, authContext);
  }


  let linkid = getParameter('linkid');
  if (linkid) {
    saveSessionData('linkid', linkid);
  }
}


function App(props: ApplicationProps) {

  const [state, setState] = useState<AppState>(
    {
      customizingId: getParameter('cid'),
      customizing: selectTheme(getParameter('cid')),
    }
  );





  initTokenAuth();




  function saveCID() {
    saveSessionData('cid', getCustomizingID(window.location.href));
  }

  saveCID();
  
  function saveKundenakteShortUrl() {
    let kundenakteShortUrl = getParameter("kundenakteShortUrl") as string | undefined;
    if (kundenakteShortUrl) {
      if (!kundenakteShortUrl.startsWith("http")) {
        LinkedappBackend
          .getRedirectUrl(kundenakteShortUrl, getParameter("cid") as "rd" | "rl" | "cl", "linkedapp")
          .then(result => {
            console.log("RESULT", result)
            result !== undefined && saveSessionData('kundenakteShortUrl', result)
          });
      }
      else {
        saveSessionData('kundenakteShortUrl', kundenakteShortUrl);
      }
    }
  }



  saveKundenakteShortUrl();
  // Theme aktualisieren, sobald sich die CustomizingID ändert.
  useEffect(
    () => {
      let customizing = selectTheme(state.customizingId);
      if (customizing !== null && customizing.title !== null) {
        document.title = 'Digitales Postfach';
      }
      setState(prevState => {
        return { ...prevState, customizing: customizing };
      });
    }, [state.customizingId]
  );

  useEffect(() => {
  }, [state.vermittlerDaten]);

  // Theme initial aus dem URL-Parameter laden
  // Session laden
  // Logger initialisieren


  useEffect(() => {
    console.log("%c Rhein%cLand %c LinkedApp Dashboard", "background: #0069b4; color: #FFFFFF", "background: #009767; color: #FFFFFF", "background: #ffffff; color: #222222");
    let isDebug = loadStorageData("isDebug") === true;
    initLogger(isDebug);
    setState(prevState => {
      return { ...prevState, customizingId: getCustomizingID(window.location.href) };
    });
  }, []);


  return (
    <StyledEngineProvider injectFirst>

{ process.env.REACT_APP_MATOMO_ITU &&
      <script dangerouslySetInnerHTML={{
        __html: `
<!-- Matomo -->
<script type="text/javascript">
var _paq = window._paq = window._paq || [];
/* tracker methods like "setCustomDimension" should be called before "trackPageView" */
_paq.push(['trackPageView']);
_paq.push(['enableLinkTracking']);
(function() {
var u="https://shoulder.dcproducts.de/";
_paq.push(['setTrackerUrl', u+'matomo.php']);
_paq.push(['setSiteId', '21']);
var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
})();
</script>
<!-- End Matomo Code -->
` }} async />}




      <ThemeProvider theme={BASIC_THEME(state.customizing)}>
        <CssBaseline />
        <Router basename={process.env.REACT_APP_LINKEDAPP_BASENAME}>
          <FilterProvider>
            <LandingProvider>
              <CustomerDataProvider>
                <Box className="linked-app" sx={{
                  minHeight: "100%"


                }}>
                  <Header appState={state} />
                  <div className={"content-wrapper content-" + state.customizingId}>
                    <Routes>
                      <Route path="/" element={
                        sindLinkParameterVorhanden() ? (
                        <Box><GreetingElement appState={state} text="lesen und speichern Sie alle Dokumente zu Ihren Versicherungsverträgen." />
                        <Reporting /></Box>): (
                          <Navigate to={getLandingPageMandantForLandingPage()}/>
                        )
                      }>

                      </Route>
                      <Route path="/abmelden" element={<Box><Account appState={state} /></Box>}></Route>
                      <Route path="/404" element={<Box><Error404 /></Box>}></Route>
                      <Route path="/impressum" element={<Box><Impressum appState={state} /></Box>}></Route>
                      <Route path="/neuladen" element={<Box><NeuAnmelden /></Box>}></Route>
                      <Route path="/landing/registrieren" element={<Box><Landing appState={state} landingSubmitType={LandingSubmitType.SIGNUP} /></Box>}></Route>
                      <Route path="/landing/bereitsregistriert" element={<Box><Landing appState={state} landingSubmitType={LandingSubmitType.SIGNUP} showBereitsregistriert={true} /></Box>}></Route>
                      <Route path="/landing/emailauswahl" element={<Box><LandingEmailAuswahl appState={state} landingSubmitType={LandingSubmitType.SIGNUP} /></Box>}></Route>
                      <Route path="/landing/registrierendanke" element={<Box><SignupDanke appState={state} landingSubmitType={LandingSubmitType.SIGNUP} /></Box>}></Route>
                      <Route path="/landing/abmelden" element={<Box><Landing appState={state} landingSubmitType={LandingSubmitType.SINGOFF} /></Box>}></Route>
                      <Route path="/ContactChange" element={<Box><GreetingElement appState={state} text="ändern Sie hier Ihre Kontaktdaten für das Digitale Postfach." />
                        <ContactChange appState={state} /></Box>}>

                      </Route>
                      <Route path="*" element={<Box><Error404 /></Box>}>

                      </Route>
                    </Routes>
                  </div>
                  {/* DK-373 */}
                  <Box sx={{height:"40px"}}></Box>
                  <Box className='footerContainer'>
                    <Trustelement appState={state} />
                    <Footer appState={state} />
                  </Box>
                </Box>

              </CustomerDataProvider>
            </LandingProvider>
          </FilterProvider>
        </Router>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
